import qs from 'qs';
import apiClient from './apiClient';
import globalData from '../globalData'
import { history } from 'modules/navigator';

export class User {
  public async init() {
    const { token } = qs.parse(window.location.search.replace('?', ''));

    if (typeof token === 'string' && localStorage.getItem('oauth')) {
      this.setToken(token);
    }

    if (this.token) {
      return;
    }
  }

  public get token() {
    if(process.env.NODE_ENV == 'development') {
      //测试token
      return 2;
    }
    return localStorage.getItem('token');
  }

  public get authorized() {
    return !!this.token;
  }

  public logout() {
    localStorage.removeItem('token');
  }

  public async login() {
    await apiClient.base.oauth({ mp: 'wxgzj' });
  }

  public setToken(token: string) {
    localStorage.setItem('token', token);
    localStorage.removeItem('oauth');
  }

  /**
   * userinfo
   *
   * @private
   * @type {{
   *     mobile?: string;
   *   }}
   * @memberof User
   **/
  private userinfo: {
    mobile?: string;
  } | null = null;

  /**
   * 获取用户信息
   *
   * @returns
   * @memberof User
   */
  public async getUserinfo(skip?:boolean) {
    if (!this.token) {
      return null;
    }

    if (this.userinfo) {
      return this.userinfo;
    }

    const { body } = await apiClient.base.wxbUserinfo({});
    this.userinfo = body;
    return body;
  }

  /**
   * 获取手机号
   *
   * @returns
   * @memberof User
   */
  public async getUserPhone() {
    const userinfo = await this.getUserinfo();

    return userinfo? userinfo.mobile || null : null;
  }

  /**
   * 必须授权手机号
   *
   */
  public requireMobile = async () => {
    const { body } = await apiClient.base.wxbUserinfo({});
    // const phone = await this.getUserPhone();
    const phone = body? body.mobile : null
    if (!this.token) {
      this.login()
      return false;
    }
    if(!phone || phone == '') {
      alert('需要先授权手机号！')
      history.push('/bindPhone')
      // alert('请前往小程序授权手机号！')
      return false;
    }
    return true
  }

  /**
   * 获取会员信息
   *
   * @returns
   * @memberof User
   */
  private vipInfo = null;
  public async getVipInfo() {
    const userInfo = await this.getUserinfo();
    if(!userInfo){return null}
    if(this.vipInfo) {
      return this.vipInfo;
    }
    const res = await apiClient.base.wxbMemberInfo();
    this.vipInfo = res.body || null;
    return res? res.body || null : null;
  }
}

export const user = new User();

const store = {
  user,
  globalData
};

export default store;
